import { cn } from "../../../lib/utils";

const TONES = {
  active: "bg-[var(--status-published-bg)] text-[var(--status-published-fg)]",
  expired: "bg-[var(--status-archived-bg)] text-[var(--status-archived-fg)]",
};

export default function StatusPill({ status }) {
  const tone = status ? TONES.active : TONES.expired;
  const label = status ? "Active" : "Inactive";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap tracking-wide",
        tone
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

/**
 * Toggle-switch used in place of a separate "Activate/Deactivate" button —
 * pairs with StatusPill so flipping a tenant's active state is a single
 * click/tap on the switch itself, with the pill reflecting the result
 * right next to it.
 */
export function StatusToggle({ checked, onChange, disabled, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label || (checked ? "Deactivate" : "Activate")}
      title={checked ? "Deactivate" : "Activate"}
      onClick={onChange}
      disabled={disabled}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2",
        checked ? "bg-[var(--color-primary)]" : "bg-[var(--color-text-border)]",
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      )}
    >
      <span
        className={cn(
          "inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-sm transition-transform duration-200",
          checked ? "translate-x-[22px]" : "translate-x-[3px]"
        )}
      />
    </button>
  );
}

/**
 * Convenience combo — the toggle and the pill rendered together, which is
 * how every "Status" column in Tenant Registry actually uses them.
 */
export function StatusToggleWithPill({ checked, onChange, disabled }) {
  return (
    <div className="flex items-center gap-2.5">
      <StatusToggle checked={checked} onChange={onChange} disabled={disabled} />
      <StatusPill status={checked} />
    </div>
  );
}
